export const blockIconsNavigationMenuOpen = (
	<span className='material-symbols-outlined'>menu_open</span>
);
